var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            {
              staticClass: "single container-max page-content",
              class: {
                "no-multiple-images": _vm.currentVariation.images.all.length < 2
              }
            },
            [
              _vm._t("dropzone2"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row position-relative teaser-wrapper" },
                [
                  _c(
                    "div",
                    { staticClass: "col-12 col-lg-6 position-static" },
                    [_vm._t("image-carousel")],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-lg-6" }, [
                    _c(
                      "div",
                      { staticClass: "single-right-content" },
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "h2 title",
                            attrs: { "data-testing": "item-name" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.currentVariation.texts.name2) +
                                  "\n                                "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "single-description" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t   " +
                              _vm._s(_vm.currentVariation.texts.name3) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr", { staticClass: "single-short-hr" }),
                        _vm._v(" "),
                        _vm._t("before-price"),
                        _vm._v(" "),
                        !_vm.isArchive
                          ? _c("item-price", {
                              attrs: {
                                "show-cross-price": _vm.isRecommendedPriceActive
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isArchive
                          ? _c(
                              "span",
                              { staticClass: "vat small text-muted" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      "data-toggle": "modal",
                                      href: "#shippingscostscustom",
                                      title: _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    }
                                  },
                                  [
                                    _vm.showNetPrices
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemExclVAT"
                                              )
                                            )
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemInclVAT"
                                              )
                                            )
                                          )
                                        ],
                                    _vm._v(
                                      ", " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemShippingCosts"
                                          )
                                        )
                                    )
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("after-price"),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [_vm._t("before-add-to-basket")],
                              2
                            ),
                            _vm._v(" "),
                            _vm.currentVariation.item.itemType === "set"
                              ? _c(
                                  "div",
                                  { staticClass: "alert alert-info w-100" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemSetInfo"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-sm-7 col-md-12 col-lg-12 basket-wrapper d-flex justify-content-center add-to-basket-wrapper"
                                    },
                                    [
                                      _c("add-to-basket", {
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id,
                                          "is-salable":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-children":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .hasActiveChildren,
                                          "interval-quantity":
                                            _vm.currentVariation.variation
                                              .intervalOrderQuantity || 1,
                                          "minimum-quantity":
                                            _vm.currentVariation.variation
                                              .minimumOrderQuantity,
                                          "maximum-quantity":
                                            !!_vm.currentVariation.variation
                                              .maximumOrderQuantity &&
                                            _vm.currentVariation.variation
                                              .maximumOrderQuantity > 0
                                              ? _vm.currentVariation.variation
                                                  .maximumOrderQuantity
                                              : null,
                                          "order-properties": _vm.currentVariation.properties.filter(
                                            function(prop) {
                                              return prop.property
                                                .isOderProperty
                                            }
                                          ),
                                          "has-order-properties":
                                            _vm.currentVariation
                                              .hasOrderProperties,
                                          "has-required-order-property":
                                            _vm.currentVariation
                                              .hasRequiredOrderProperty,
                                          "use-large-scale": false,
                                          "show-quantity": true,
                                          "is-single": true,
                                          "is-archive": _vm.isArchive,
                                          "item-url": _vm._f("itemURL")(
                                            _vm.currentVariation
                                          ),
                                          "is-variation-selected":
                                            _vm.isVariationSelected &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-price": _vm._f(
                                            "hasItemDefaultPrice"
                                          )(_vm.currentVariation),
                                          "show-checkout": false,
                                          "primary-btn": true
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-sm-7 col-md-12 col-lg-12 basket-wrapper d-flex justify-content-center"
                                    },
                                    [
                                      _c("add-to-basket", {
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id,
                                          "is-salable":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-children":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .hasActiveChildren,
                                          "interval-quantity":
                                            _vm.currentVariation.variation
                                              .intervalOrderQuantity || 1,
                                          "minimum-quantity":
                                            _vm.currentVariation.variation
                                              .minimumOrderQuantity,
                                          "maximum-quantity":
                                            !!_vm.currentVariation.variation
                                              .maximumOrderQuantity &&
                                            _vm.currentVariation.variation
                                              .maximumOrderQuantity > 0
                                              ? _vm.currentVariation.variation
                                                  .maximumOrderQuantity
                                              : null,
                                          "order-properties": _vm.currentVariation.properties.filter(
                                            function(prop) {
                                              return prop.property
                                                .isOderProperty
                                            }
                                          ),
                                          "has-order-properties":
                                            _vm.currentVariation
                                              .hasOrderProperties,
                                          "has-required-order-property":
                                            _vm.currentVariation
                                              .hasRequiredOrderProperty,
                                          "use-large-scale": false,
                                          "show-quantity": false,
                                          "is-single": true,
                                          "is-archive": _vm.isArchive,
                                          "item-url": _vm._f("itemURL")(
                                            _vm.currentVariation
                                          ),
                                          "is-variation-selected":
                                            _vm.isVariationSelected &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-price": _vm._f(
                                            "hasItemDefaultPrice"
                                          )(_vm.currentVariation),
                                          "show-checkout": true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [_vm._t("after-add-to-basket")],
                              2
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.isWishListEnabled
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-12 single-wishlist-wrapper"
                                },
                                [
                                  _c("add-to-wish-list", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "btn question-modal-btn",
                              attrs: { type: "button" },
                              on: { click: _vm.updateAndOpenModal }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor"
                                  }
                                },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#question2" }
                                  })
                                ]
                              ),
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$translate(
                                      "HoferAntikschmuck::Template.itemQuestion"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket"),
                        _vm._v(" "),
                        _vm._t("additional-content-after-vat")
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "hofer-hr__wrapper d-lg-none" }, [
                _c("div", { staticClass: "hofer-hr" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "mobile-nav__chevron",
                      attrs: { fill: "currentColor" }
                    },
                    [_c("use", { attrs: { "xlink:href": "#logo-minimal" } })]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container-inner description__wrapper" },
                [
                  _vm.descImg.url !== "" && typeof _vm.descImg !== "undefined"
                    ? _c("img", {
                        staticClass: "description__img d-sm-none d-xl-block",
                        attrs: {
                          src: _vm.descImg.url,
                          title: _vm.currentVariation.texts.name3,
                          alt: _vm.currentVariation.texts.name3
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "description__content",
                      class: {
                        "description__content--open": _vm.showMoreMobile
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "description__txt" },
                        [
                          _vm.descImg.url !== "" &&
                          typeof _vm.descImg !== "undefined"
                            ? _c("img", {
                                staticClass:
                                  "description__img description__img--mobile d-none d-sm-block d-xl-none",
                                attrs: {
                                  src: _vm.descImg.url,
                                  title: _vm.currentVariation.texts.name3,
                                  alt: _vm.currentVariation.texts.name3
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "description__headline" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "HoferAntikschmuck::Template.descriptionHeadline"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.allProperties, function(prop) {
                            return prop.id === 38 &&
                              prop.values.value === "auto" &&
                              _vm.lang !== "de"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "description__translation-info"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "description__translation-icon"
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "20",
                                              height: "20",
                                              fill: "currentColor"
                                            }
                                          },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href": "#info-circle"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "description__translation-txt"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$translate(
                                                "HoferAntikschmuck::Template.translationHint"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.description
                              )
                            }
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.quote !== "" &&
                      typeof _vm.quote !== "undefined" &&
                      _vm.quoteAuthor !== ""
                        ? _c(
                            "div",
                            { staticClass: "description__quote-wrapper" },
                            [
                              _vm.quoteImg !== ""
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.quoteImg,
                                      alt: _vm.quoteAuthor
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "description__quote-content-wrapper"
                                },
                                [
                                  _c(
                                    "q",
                                    { staticClass: "description__quote" },
                                    [_vm._v(_vm._s(_vm.quote))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "description__quote-author"
                                    },
                                    [_vm._v(_vm._s(_vm.quoteAuthor))]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.texts.technicalData
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "description__txt description__txt--2",
                              class: {
                                "description__txt--open":
                                  _vm.showMore || _vm.showMoreMobile
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "description__headline description__headline--2"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "HoferAntikschmuck::Template.lernMore"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.technicalData
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.texts.technicalData !== "" &&
                      !_vm.showMoreMobile
                        ? _c(
                            "div",
                            {
                              staticClass: "description__show-more",
                              class: {
                                "description__show-more--open": _vm.showMore
                              },
                              on: {
                                click: function($event) {
                                  _vm.showMore = !_vm.showMore
                                }
                              }
                            },
                            [
                              !_vm.showMore
                                ? _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "8",
                                        height: "8",
                                        fill: "currentColor"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#plus" }
                                      })
                                    ]
                                  )
                                : _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "8",
                                        height: "8",
                                        fill: "currentColor"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#minus" }
                                      })
                                    ]
                                  ),
                              _vm._v(
                                "\n\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$translate(
                                      "HoferAntikschmuck::Template.lernMore"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.showMoreMobile
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "description__show-more-mobile d-md-none",
                          class: {
                            "description__show-more-mobile--open":
                              _vm.showMoreMobile
                          },
                          on: {
                            click: function($event) {
                              _vm.showMoreMobile = !_vm.showMoreMobile
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "8",
                                height: "8",
                                fill: "currentColor"
                              }
                            },
                            [_c("use", { attrs: { "xlink:href": "#plus" } })]
                          ),
                          _vm._v(
                            "\n\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$translate(
                                  "HoferAntikschmuck::Template.readMore"
                                )
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              !_vm.isCoupon
                ? _c("div", { staticClass: "details__bg" }, [
                    _c(
                      "div",
                      { staticClass: "details__wrapper container-inner" },
                      [
                        _c(
                          "div",
                          { staticClass: "details__content" },
                          [
                            _c("div", { staticClass: "details__headline" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "HoferAntikschmuck::Template.detailsHeadline"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("client-only", [_vm._t("item-props")], 2)
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "details__video" }, [
                          _c(
                            "div",
                            { staticClass: "single__video-right" },
                            [
                              _vm.videoProp !== ""
                                ? [
                                    _vm.videoProp.values.value &&
                                    _vm.videoProp.values.value !== ""
                                      ? _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.videoPlaying,
                                                expression: "!videoPlaying"
                                              }
                                            ],
                                            staticClass: "single__video-play",
                                            on: {
                                              click: function($event) {
                                                return _vm.videoPlay()
                                              }
                                            }
                                          },
                                          [
                                            _c("svg", [
                                              _c("use", {
                                                attrs: { "xlink:href": "#play" }
                                              })
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.videoProp.values.value &&
                                    _vm.videoProp.values.value !== ""
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "video-wrapper",
                                            class: { playing: _vm.videoPlaying }
                                          },
                                          [
                                            _c("video", {
                                              ref: "video",
                                              staticClass:
                                                "single__video-player",
                                              attrs: {
                                                playsinline: "",
                                                muted: "",
                                                loop: "",
                                                preload: "none",
                                                src: _vm.videoProp.values.value.replace(
                                                  "http:",
                                                  "https:"
                                                ),
                                                poster: _vm.replacePoster(
                                                  _vm.videoProp.values.value.replace(
                                                    "http:",
                                                    "https:"
                                                  )
                                                )
                                              },
                                              domProps: { muted: true },
                                              on: {
                                                click: function($event) {
                                                  return _vm.videoPause()
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      : _vm.videoImg.url &&
                                        _vm.videoImg.url !== "" &&
                                        typeof _vm.videoImg.url !== "undefined"
                                      ? _c("img", {
                                          attrs: {
                                            src: _vm.videoImg.url,
                                            alt: "video"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                : _vm.videoImg.url &&
                                  _vm.videoImg.url !== "" &&
                                  typeof _vm.videoImg.url !== "undefined"
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.videoImg.url,
                                      alt: "video"
                                    }
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isArchive
                ? _c("div", { staticClass: "small-add-to-basket" }, [
                    _c("img", {
                      staticClass: "small-add-to-basket__img",
                      attrs: {
                        src: _vm.currentVariation.images.all[0].url,
                        title: _vm.currentVariation.texts.name3,
                        alt: _vm.currentVariation.texts.name3
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "small-add-to-basket__content" },
                      [
                        _c(
                          "span",
                          { staticClass: "small-add-to-basket__item-name" },
                          [_vm._v(_vm._s(_vm.currentVariation.texts.name2))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "small-add-to-basket__price-vat-wrapper"
                          },
                          [
                            _c("item-price", {
                              attrs: {
                                "show-cross-price": _vm.isRecommendedPriceActive
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "vat small text-muted" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      "data-toggle": "modal",
                                      href: "#shippingscostscustom",
                                      title: _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    }
                                  },
                                  [
                                    _vm.showNetPrices
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemExclVAT"
                                              )
                                            )
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemInclVAT"
                                              )
                                            )
                                          )
                                        ],
                                    _vm._v(
                                      ", " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemShippingCosts"
                                          )
                                        )
                                    )
                                  ],
                                  2
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("add-to-basket", {
                          attrs: {
                            "is-archive": _vm.isArchive,
                            "variation-id": _vm.currentVariation.variation.id,
                            "is-salable":
                              !!_vm.currentVariation.filter &&
                              _vm.currentVariation.filter.isSalable,
                            "has-children":
                              !!_vm.currentVariation.filter &&
                              _vm.currentVariation.filter.hasActiveChildren,
                            "interval-quantity":
                              _vm.currentVariation.variation
                                .intervalOrderQuantity || 1,
                            "minimum-quantity":
                              _vm.currentVariation.variation
                                .minimumOrderQuantity,
                            "maximum-quantity":
                              !!_vm.currentVariation.variation
                                .maximumOrderQuantity &&
                              _vm.currentVariation.variation
                                .maximumOrderQuantity > 0
                                ? _vm.currentVariation.variation
                                    .maximumOrderQuantity
                                : null,
                            "order-properties": _vm.currentVariation.properties.filter(
                              function(prop) {
                                return prop.property.isOderProperty
                              }
                            ),
                            "has-order-properties":
                              _vm.currentVariation.hasOrderProperties,
                            "has-required-order-property":
                              _vm.currentVariation.hasRequiredOrderProperty,
                            "use-large-scale": false,
                            "show-quantity": false,
                            "is-single": true,
                            "item-url": _vm._f("itemURL")(_vm.currentVariation),
                            "is-variation-selected":
                              _vm.isVariationSelected &&
                              _vm.currentVariation.filter.isSalable,
                            "has-price": _vm._f("hasItemDefaultPrice")(
                              _vm.currentVariation
                            ),
                            "show-checkout": false,
                            "primary-btn": true
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("dropzone1"),
              _vm._v(" "),
              _vm._t("item-list-container"),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }